import { Icon } from '@iconify/react';
import { isIPenPlatformDomainEntity } from '@ipen-portal/plugin-common';
import {
  type EntityListFilterProps,
  type EntityListToolbarProps,
  makeEntityContentWithToolbar,
} from '@ipen-portal/plugin-layout-react';

export const PartnerSystemsEntityContent = makeEntityContentWithToolbar({
  name: 'PartnerSystemsEntityContent',
  params: {
    filter: isIPenPlatformDomainEntity,
    icon: <Icon icon="carbon:partnership" />,
    loader: async () =>
      import('./components/PartnerSystemList').then(m => (
        <m.PartnerSystemList />
      )),
    path: '/partner-systems',
    title: 'Partner Systems',
    toolbarProps: {
      creationTemplateRef: 'ipen-partner-system',
    } satisfies EntityListToolbarProps,
    wrapperProps: {
      kindFilter: 'system',
      typeFilter: 'partner-system',
    } satisfies EntityListFilterProps,
  },
});
